import axios from "../../config/axios"

function create(data) {
    return axios().post("/purchase/general-receipts", data);
}

function findByID(id) {
    return axios().get(`/purchase/general-receipts/${id}`);
}

function index(params) {
    params = {...params, limit: params.itemsPerPage, offset: (params.page -1) * params.itemsPerPage };
    return axios().get(`/purchase/general-receipts`, {
        params
    })
}

function update(data) {
    return axios().put(`/purchase/general-receipts/${data.id}`, data);
}

function remove(data) {
    return axios().delete(`/purchase/general-receipts/${data.id}`);
}

function post(data) {
    return axios().put(`/purchase/general-receipts/${data.id}/post`);
}

function print(data) {
    return axios().get(`/purchase/general-receipts/${data.id}/print`);
}

export default {
    create,
    findByID,
    index,
    update,
    remove,
    post,
    print
}